
// Dependencies
import formMessage from '../utility/form-message';

// Components
import GoogleMap from '../components/google-map';

// Constants
const googleMapConfig = {
  backgroundColor: '#faf9f3',
  center: {
    lat: 30,
    lng: 10,
  },
  clickableIcons: false,
  disableDefaultUI: true,
  disableDoubleClickZoom: true,
  scaleControl: false,
  scrollwheel: false,
  styles: [
    {
      featureType: 'all',
      stylers: [
        {
          color: '#faf9f3',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry',
      stylers: [
        {
          color: '#212322',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'administrative.country',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
  ],
  zoom: 2,
  zoomControl: false,
};
const googleMap = new GoogleMap(
  document.getElementById('clients-map'),
  googleMapConfig
);

google.maps.event.addDomListener(window, 'load', googleMap.init);



// WEBPACK FOOTER //
// ./pages/clients.js